import FormattedMessage from 'I18n/components/FormattedMessage';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuizMeAnswers = ({
  handleSelectAnswerIndexChange,
  questionAnswered,
  questionIndex,
  quizQuestions,
  selectedAnswerIndex
}) => {
  const handleSelectAnswerClick = (answerIndex, correct) => () => handleSelectAnswerIndexChange(answerIndex, correct);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "stretch",
    flexDirection: "column",
    marginInlineEnd: "700",
    children: [/*#__PURE__*/_jsx(AccordionTransition, {
      marginBlockStart: "400",
      open: !questionAnswered,
      children: quizQuestions[questionIndex].answers.map((answer, index) => /*#__PURE__*/_jsx(SelectableButton, {
        block: true,
        "data-test-id": `quiz-me-answer-${index}`,
        marginBlock: "400",
        onClick: handleSelectAnswerClick(index, answer.correct),
        selected: selectedAnswerIndex === index,
        title: answer.answerOptionText,
        type: "default"
      }, index))
    }), selectedAnswerIndex !== undefined && /*#__PURE__*/_jsxs(AccordionTransition, {
      open: questionAnswered,
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        marginBlock: "800",
        children: [/*#__PURE__*/_jsx(IconCircle, {
          backgroundColor: quizQuestions[questionIndex].answers[selectedAnswerIndex].correct ? 'fill-positive-default' : 'fill-alert-default',
          borderColor: quizQuestions[questionIndex].answers[selectedAnswerIndex].correct ? 'border-positive-default' : 'border-alert-default',
          color: "fill-surface-default",
          icon: quizQuestions[questionIndex].answers[selectedAnswerIndex].correct ? SuccessIcon : RemoveIcon,
          size: "100"
        }), /*#__PURE__*/_jsx(Text, {
          as: "strong",
          color: quizQuestions[questionIndex].answers[selectedAnswerIndex].correct ? 'fill-positive-default' : 'text-alert-default',
          marginInlineStart: "400",
          children: quizQuestions[questionIndex].answers[selectedAnswerIndex].correct ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.correct"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.incorrect"
          })
        })]
      }), !quizQuestions[questionIndex].answers[selectedAnswerIndex].correct && /*#__PURE__*/_jsx(Text, {
        children: quizQuestions[questionIndex].answers[selectedAnswerIndex].answerExplanationDetails
      })]
    })]
  });
};
export default QuizMeAnswers;